import { useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys, type StatisticPeriod } from '../api/dashboard.api';

export function useMDNps(period: StatisticPeriod) {
  return useQuery({
    queryKey: dashboardQueryKeys.mdNps(period),
    queryFn: () => dashboardApi.getMDNps(period),
  });
}
